<template>
    <div v-wechat-title="title">
        <DocFrame ref="doc" :style="{ 'overflow-y': `auto`, height: `${this.screenHeight - 80}px` }" :docbizid.sync="docbizid" :docno="docid" :surgeryId="surgeryid" @saved="afterDocSaved"></DocFrame>
        <CloseButton ref="close-btn" type="confirm" :showPrint="showPrint" @confirm="SaveChanges" :data="data" :msg="msg"> </CloseButton>
    </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
    name: `KeyEventEditDoc`,
    props: {},
    data() {
        return {
            title: `填写患者文书`,
            token: this.$route.query.token,
            surgeryid: this.$route.query.surgeryid,
            docid: this.$route.query.docid,
            permissions: [],
            showPrint: false,
            docbizid: ``,
            scalenum: 1,
            document: {},
            data: {},
            msg: `closeWindow`
        }
    },
    created() {
        sessionStorage.setItem(`token`, this.token)
        this.getToken()
        this.loadPermissions()
        this.$store.dispatch(`ADD_CURRENTUSER`).then(() => {
            this.init()
        })
    },
    computed: {
        ...mapGetters([`screenHeight`, `currentUser`, `permissions`])
    },
    methods: {
        getToken() {
            let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/GetAuthToken`, {
                headers: { 'content-type': `application/x-www-form-urlencoded` }
            })
            req.then(res => {
                console.log(`11111111111111111111111`, res)
                if (res != null && res.Status === `SUCCESS`) {
                    sessionStorage.setItem(`doctoken`, res.Content)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        loadPermissions() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            req.then(data => {
                this.permissions = data
                this.showPrint = data && data.findIndex(item => item.permission === `surgery_list:docPrint`) != -1
            }).catch(e => {
            })
        },
        init() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = axios.get(`${this.$root.DOCSERVICE_BASE}/DocCenter/Setting/GetDicDocManagementList`, {
                    headers: { 'content-type': `application/x-www-form-urlencoded`, 'Authorization': sessionStorage.getItem(`doctoken`) },
                    params: { deptno: `acis2020`, permission: `0-11111111111`, vid: this.surgeryid }
                })
                req.then(docmanagement => {
                    let documentList = _.filter(_.orderBy(docmanagement.data, `PrintOrder`), d => {
                        return d.DocNo == that.docid
                    })
                    console.log(`documentList`)
                    console.log(documentList)
                    if (documentList) {
                        that.document = documentList[0]
                        that.loadInstances(that.document)
                    }
                    resolve(that.document)
                })
            })
        },
        loadInstances(document) {
            let that = this
            let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/QueryInstances`, {
                headers: { 'content-type': `application/x-www-form-urlencoded` },
                params: { docid: that.docid, dept: `acis2020`, vid: that.surgeryid, operator: that.currentUser.dic_worker_name }
            })
            req.then(data => {
                console.log(`doc`)
                let list = _.filter(data.Content, d => { return d.istemplate == `0` && d.docid == document.DocId })
                console.log(list)
                if (list && list.length > 0) {
                    console.log(list && list[0])
                    this.docbizid = list && list[0].docbizid || ``
                }
                this.$refs[`doc`].loadDocument()
            })
        },
        SaveChanges() {
            this.$refs.doc.save()
        },
        afterDocSaved() {
            if (this.showPrint) {
                this.$refs.doc.print()
            } else {
                this.$refs[`close-btn`].close()
            }
        }
    },
    watch: {}
}
</script>
<style scoped>
.note {
    display: inline-block;
    position: absolute;
    left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/KeyEventEditDoc.vue